module.exports = __webpack_public_path__ + "static/beerfarm-b679a60c55b90a2a4448db7f30a548e4.jpg";